import React, { useEffect, useState } from "react"
import { useAppDispatch } from "../../../store"
import { setCurrentPage } from "../../../store/auth/authReducer"
import { Navigate, useLocation } from "react-router-dom"
import axios from "axios"
import Box from "@mui/material/Box"
import TextField from "@mui/material/TextField"
import Button from "@mui/material/Button"
import Snackbar from "@mui/material/Snackbar"
import Alert from "@mui/material/Alert"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import { useSelector } from "react-redux"
import { logOut } from "../../../utils/logOut"
import { useSnackbar } from "../../../utils/SnackbarContext"
import TranslatedText from "../../../utils/Translate"
import { Tooltip } from "@mui/material"

export default function ApiServicesLoadbalancingRule() {
    const dispatch = useAppDispatch()
    const location = useLocation()
    const [openSnackbar, setOpenSnackbar] = useState(false)
    const [snackbarType, setSnackbarType] = useState("")
    const { showSnackbar } = useSnackbar();

    //Get params from URL
    const params = new URLSearchParams(location.search);
    const id = params.get('id');
    const type: string | null = params.get('type')

    //Get access level
    const accesslevel = useSelector(
        (state: any) => state.auth.authData.accesslevel
    )

    const [services, setServices] = useState([])
    const [vendors, setVendors] = useState([])

    //Switch header title

    useEffect(() => {
        dispatch(setCurrentPage(type === "edit" ? `Edit Load Balancing Rule` : 'Add Load Balancing Rule'))
    }, [dispatch]);

    //Handle close snackbar
    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };


    //Making request to get vendors list
    async function getVendors(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/apivendors`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data);
            setVendors(response.data)
        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Making request to get services list
    async function getServices(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/apiservices`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data);
            setServices(response.data)

        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    const getInitialApiServiceLoadbalancingRule = () => ({
        api_service: '',
        api_vendor: '',
        weight: '',
        priority: '',
        limit: '',
        code: '',
        add_parameters: ''
    })

    const normalizeSelectValue = (value: unknown) => value === null || value === undefined ? '' : String(value)

    //Get user
    async function fetchData(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/apiservicesloadbalancing/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })

            if (response.data !== null) {
                if (typeof (response.data) === 'object') {
                    const rule = response.data[0]
                    setApiServiceLoadbalancingRule({
                        ...getInitialApiServiceLoadbalancingRule(),
                        ...rule,
                        api_vendor: normalizeSelectValue(rule.api_vendor),
                        api_service: normalizeSelectValue(rule.api_service),
                    })
                }
                else showSnackbar('ERROR: INVALID SERVER RESPONSE', 'error')
            }

            console.log(response.data[0]);

        } catch (error: any) {
            console.log(error);
            if (error.code === "ERR_BAD_REQUEST") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Create contact group
    async function postData(data: any = {}) {
        try {
            const response = await axios.post(`https://cardgarantsales.com/restapi/apiservicesloadbalancing`, {
                ...data
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            setSnackbarType('success')
            setOpenSnackbar(true)
        } catch (error: any) {
            setSnackbarType('error')
            setOpenSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Edit contact group
    async function putData(data: any = {}) {
        try {
            const response = await axios.put(`https://cardgarantsales.com/restapi/apiservicesloadbalancing/${id}`, {
                ...data,
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            setSnackbarType('success')
            setOpenSnackbar(true)
        } catch (error: any) {
            setSnackbarType('error')
            setOpenSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }


    const [apiServiceLoadbalancingRule, setApiServiceLoadbalancingRule] = useState<any>(getInitialApiServiceLoadbalancingRule())


    //On load if URL params contains type=edit
    useEffect(() => {
        getServices()
        getVendors()
        type === 'edit' && fetchData()
        console.log(apiServiceLoadbalancingRule);

    }, [type])

    return (
        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
            <Box>
                <Box sx={{ width: 500, display: "flex", mb: 2, flexWrap: "wrap", gap: 2 }}>
                    <TextField sx={{ width: 500 }} label={<TranslatedText text={'Code'} />} variant="outlined" size="small" value={apiServiceLoadbalancingRule.code || ''} onChange={(e) => setApiServiceLoadbalancingRule({ ...apiServiceLoadbalancingRule, code: e.target.value })} />
                    <FormControl>
                        <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Vendor'} /></InputLabel>
                        <Select sx={{ width: 500 }} labelId="simple-select-label" onChange={(e) => setApiServiceLoadbalancingRule({ ...apiServiceLoadbalancingRule, api_vendor: e.target.value })} value={normalizeSelectValue(apiServiceLoadbalancingRule.api_vendor)} variant="outlined" size="small" label={<TranslatedText text={'Vendor'} />} >
                            {
                                vendors.map((el: any) => {
                                    //make vendors list item
                                    return (
                                        <MenuItem key={el.id} value={normalizeSelectValue(el.id)}>{el.name}</MenuItem>
                                    )
                                })
                            }
                        </Select>
                    </FormControl>
                    <FormControl>
                        <InputLabel size="small" id="simple-select-label"><TranslatedText text={'API Service'} /></InputLabel>
                        <Select sx={{ width: 500 }} labelId="simple-select-label" onChange={(e) => setApiServiceLoadbalancingRule({ ...apiServiceLoadbalancingRule, api_service: e.target.value })} value={normalizeSelectValue(apiServiceLoadbalancingRule.api_service)} variant="outlined" size="small" label={<TranslatedText text={'API Service'} />} >
                            {
                                services.map((el: any) => {
                                    //make services list item
                                    return (
                                        <MenuItem key={el.id} value={normalizeSelectValue(el.id)}>{el.name}</MenuItem>
                                    )
                                })
                            }
                        </Select>
                    </FormControl>
                    <TextField sx={{ width: 500 }} label={<TranslatedText text={'Weight'} />} variant="outlined" size="small" value={apiServiceLoadbalancingRule.weight || ''} onChange={(e) => setApiServiceLoadbalancingRule({ ...apiServiceLoadbalancingRule, weight: e.target.value })} />
                    <TextField sx={{ width: 500 }} label={<TranslatedText text={'Priority'} />} variant="outlined" size="small" value={apiServiceLoadbalancingRule.priority || ''} onChange={(e) => setApiServiceLoadbalancingRule({ ...apiServiceLoadbalancingRule, priority: e.target.value })} />
                    <TextField sx={{ width: 500 }} label={<TranslatedText text={'Limit'} />} variant="outlined" size="small" value={apiServiceLoadbalancingRule.limit || ''} onChange={(e) => setApiServiceLoadbalancingRule({ ...apiServiceLoadbalancingRule, limit: e.target.value })} />
                    <Tooltip title={<TranslatedText text={'Additional Parameters in json format. example: {"key": "value"}'} />} placement="top-start">
                        <TextField sx={{ width: "100%", '& textarea': { resize: 'vertical' }, mb: 2 }}
                            label={<TranslatedText text={'Additional Parameters'} />}
                            onChange={(e) => setApiServiceLoadbalancingRule({ ...apiServiceLoadbalancingRule, add_parameters: e.target.value !== '' ? e.target.value : null })}
                            value={apiServiceLoadbalancingRule.add_parameters || ''}
                            multiline
                            rows={5}
                            fullWidth
                            variant="outlined" />
                    </Tooltip>
                </Box>
                <Button onClick={() => type === "edit" ? putData(apiServiceLoadbalancingRule) : postData(apiServiceLoadbalancingRule)} variant="contained" sx={{ width: "100%" }}>Save</Button>
            </Box>
            {type !== 'edit' && snackbarType === 'success' && <Navigate to='/apiservicesloadbalancingrules' />}
            <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleClose}>
                {snackbarType === 'error' ?
                    <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
                        Saving error
                    </Alert> :
                    <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
                        Successfully saved
                    </Alert>}
            </Snackbar>
        </Box >
    )
}